function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useWizard } from 'react-use-wizard';
import { PaymentContext } from '../../pages/billing/PaymentContext';
import routes from '../../routes/constants';
import text from '../../text';
import Button from '../button/Button';
import BottomContainer from '../containers/BottomContainer';
import T from 'prop-types';
var StepFooter = function(props) {
    var history = useHistory();
    var _useWizard = useWizard(), previousStep = _useWizard.previousStep, nextStep = _useWizard.nextStep, isFirstStep = _useWizard.isFirstStep, activeStep = _useWizard.activeStep;
    var _props_previousButtonProps = props.previousButtonProps, previousButtonProps = _props_previousButtonProps === void 0 ? {} : _props_previousButtonProps, _props_nextButtonProps = props.nextButtonProps, nextButtonProps = _props_nextButtonProps === void 0 ? {} : _props_nextButtonProps, topContent = props.topContent;
    var onClickPreviousButton = previousButtonProps.onClick, label = previousButtonProps.label, restPreviousButtonProps = _object_without_properties(previousButtonProps, [
        "onClick",
        "label"
    ]);
    var actions = useContext(PaymentContext).actions;
    useEffect(function() {
        actions.handleSetWizardStep(activeStep);
    }, [
        actions,
        activeStep
    ]);
    var onCancel = function() {
        history.push(routes.home);
    };
    return /*#__PURE__*/ React.createElement(BottomContainer, {
        className: "StepFooter"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "top"
    }, topContent), /*#__PURE__*/ React.createElement("div", {
        className: "bottom"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "left"
    }, /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        onClick: onCancel
    }, text('cancel'))), /*#__PURE__*/ React.createElement("div", {
        className: "right"
    }, !isFirstStep && /*#__PURE__*/ React.createElement(Button, _object_spread({
        variant: "outline-primary",
        onClick: onClickPreviousButton ? function() {
            return onClickPreviousButton(previousStep);
        } : previousStep
    }, restPreviousButtonProps), label || text('previous')), /*#__PURE__*/ React.createElement(Button, {
        className: "ml-3 full-width",
        onClick: (nextButtonProps === null || nextButtonProps === void 0 ? void 0 : nextButtonProps.onClick) ? function() {
            return nextButtonProps.onClick(nextStep);
        } : nextStep,
        loading: nextButtonProps.loading || false,
        disabled: nextButtonProps.disabled
    }, nextButtonProps.label || text('next')))));
};
StepFooter.propTypes = {
    previousButtonProps: T.object,
    nextButtonProps: T.object,
    topContent: T.object
};
export default StepFooter;
